module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak pieszy czarny.svg?345123c3";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak pieszy czarny.svg
// module id = 2017
// module chunks = 0